import Vue from 'vue'
const packageJson = require('../../package.json')

export function initKmui(cb) {
  const { version, ossThemeDir } = packageJson.kmuiTheme
  window.Vue = Vue
  let script = document.createElement('script')
  script.setAttribute('type', 'text/javascript')
  script.setAttribute(
    'src',
    `https://erp-qd.oss-cn-hangzhou.aliyuncs.com/kmui-core/${ossThemeDir}/${version}/index.js`
  )
  script.onerror = function(oError) {
    console.error('【KMUI index.js加载失败】, 链接: ', oError.target.src)
  }
  script.onload = function() {
    window.installKmui(Vue, {
      themeName: localStorage.getItem('kmuiThemeName') || 'default',
      ossThemeDir,
    })
    cb()
  }
  document.documentElement.appendChild(script)
}

// 清空某tab下的蒙层堆，防止有部分场景出现无法清除的蒙层数据导致蒙层关闭不了
// 参数tabId 参考 mixins/kmuiTabIdMixin.js
// 对应tab相应的路由名 $route.name
export function clearPopupStack(tabId) {
  if (!window.__popup_manager) return console.log('kmui未暴露__popup_manager, 无法清除')
  window.__popup_manager.modalStack[tabId] = []
}

export default {
  clearPopupStack
}
